/**
 * @example ${entity}_[${select}]_${effect}  - AUTH_LOGIN, AUTH_LOGIN_SUCCESS, etc.
 */
// AUTH
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
// EVAC REPLAY
export const EVAC_REPLAY_START = 'EVAC_REPLAY_START';
export const EVAC_REPLAY_FAILED = 'EVAC_REPLAY_FAILED';
export const EVAC_REPLAY_LIST_GET = 'EVAC_REPLAY_LIST_GET';
export const EVAC_REPLAY_LIST_SUCCESS = 'EVAC_REPLAY_LIST_SUCCESS';
export const EVAC_REPLAY_DATA_GET = 'EVAC_REPLAY_DATA_GET';
export const EVAC_REPLAY_DATA_SUCCESS = 'EVAC_REPLAY_DATA_SUCCESS';
// NOTOFICATIONS
export const NOTIFICATIONS_START = 'NOTIFICATIONS_START';
export const NOTIFICATIONS_FAILED = 'NOTIFICATIONS_FAILED';
export const NOTIFICATIONS_LIST_GET = 'NOTIFICATIONS_LIST_GET';
export const NOTIFICATIONS_LIST_SUCCESS = 'NOTIFICATIONS_LIST_SUCCESS';
export const NOTIFICATIONS_DELETE = 'NOTIFICATIONS_DELETE';
export const NOTIFICATIONS_DELETE_SUCCESS = 'NOTIFICATIONS_DELETE_SUCCESS';
export const NOTIFICATIONS_ADD_EDIT = 'NOTIFICATIONS_ADD_EDIT';
export const NOTIFICATIONS_ADD_EDIT_SUCCESS = 'NOTIFICATIONS_ADD_EDIT_SUCCESS';
export const NOTIFICATIONS_DETAILS_GET = 'NOTIFICATIONS_DETAILS_GET';
export const NOTIFICATIONS_DETAILS_SUCCESS = 'NOTIFICATIONS_DETAILS_SUCCESS';
export const NOTIFICATIONS_DETAILS_CLEAR = 'NOTIFICATIONS_DETAILS_CLEAR';
// SITES
export const SITES_START = 'SITES_START';
export const SITES_FAILED = 'SITES_FAILED';
export const SITES_LIST_GET = 'SITES_LIST_GET';
export const SITES_LIST_SUCCESS = 'SITES_LIST_SUCCESS';
export const SITES_ZONES_LIST_GET = 'SITES_ZONES_LIST_GET';
export const SITES_ZONES_LIST_SUCCESS = 'SITES_ZONES_LIST_SUCCESS';
export const SITES_ZONES_LIST_CLEAR = 'SITES_ZONES_LIST_CLEAR';
//HOLDERS
export const HOLDERS_START = 'HOLDERS_START';
export const HOLDERS_FAILED = 'HOLDERS_FAILED';
export const HOLDERS_LIST_GET = 'HOLDERS_LIST_GET';
export const HOLDERS_LIST_SUCCESS = 'HOLDERS_LIST_SUCCESS';
//HOLDER_ZONE_REPORTS
export const HOLDER_ZONE_REPORT_START = 'HOLDER_ZONE_REPORT_START';
export const HOLDER_ZONE_REPORT_FAILED = 'HOLDER_ZONE_REPORT_FAILED';
export const HOLDER_ZONE_REPORT_GET = 'HOLDER_ZONE_REPORT_GET';
export const HOLDER_ZONE_REPORT_SUCCESS = 'HOLDER_ZONE_REPORT_SUCCESS';
//HOLDER_ABSENCE_REPORTS
export const HOLDER_ABSENCE_REPORT_START = 'HOLDER_ABSENCE_REPORT_START';
export const HOLDER_ABSENCE_REPORT_FAILED = 'HOLDER_ABSENCE_REPORT_FAILED';
export const HOLDER_ABSENCE_REPORT_GET = 'HOLDER_ABSENCE_REPORT_GET';
export const HOLDER_ABSENCE_REPORT_SUCCESS = 'HOLDER_ABSENCE_REPORT_SUCCESS';
//VISITS
export const VISITS_START = 'VISITS_START';
export const VISITS_FAILED = 'VISITS_FAILED';
export const VISITS_LIST_GET = 'VISITS_LIST_GET';
export const VISITS_LIST_SUCCESS = 'VISITS_LIST_SUCCESS';



// WEBPACK FOOTER //
// ./src/redux/new_store_structure/actions/actionsTypes.js